import * as t from "io-ts";

const codec = t.boolean;

type T = t.TypeOf<typeof codec>;

export const hasProvidedProofOfFunds = (obj: {
    funds_cash_verified_upto: number | null;
    funds_dip_verified_upto: number | null;
}): T =>
    obj.funds_cash_verified_upto !== null || obj.funds_dip_verified_upto !== null;
